export const nameBoxSx = (showEditName) => ({
  container: {
    mx: 3,
  },

  headerStack: {
    justifyContent: "space-between",
    alignItems: "center",
    my: 4,
  },

  fieldWrapper: {
    width: "100%",
    margin: "0 auto",
  },

  actionGrid: {
    mt: 3,
  },

  buttonBox: {
    width: "90%",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
